import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var SortSVG = function SortSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M18.17 19.52a2 2 0 00-2.94 2.71l5.65 6.13a2 2 0 002.94 0l5.65-6.13a2 2 0 00-2.94-2.71l-2.19 2.37V5a2 2 0 00-4 0v16.88zM9.66 29a2 2 0 01-2-2V10.11l-2.19 2.37a2 2 0 01-2.94-2.71l5.65-6.13a2 2 0 012.94 0l5.65 6.13a2 2 0 01-2.94 2.71l-2.17-2.36V27a2 2 0 01-2 2z"
  }));
};
SortSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SortSVG);